export type LoginState =
  | { phase: 'credentials'; error: string | null }
  | { phase: 'totp'; challengeToken: string; error: string | null }

export type LoginAction =
  | { type: 'SUBMITTING' }
  | { type: 'CHALLENGE_RECEIVED'; challengeToken: string }
  | { type: 'ERROR'; message: string }
  | { type: 'RESET' }

export const initialLoginState: LoginState = {
  phase: 'credentials',
  error: null,
}

export function loginReducer(state: LoginState, action: LoginAction): LoginState {
  switch (action.type) {
    case 'SUBMITTING':
      return { ...state, error: null }
    case 'CHALLENGE_RECEIVED':
      return {
        phase: 'totp',
        challengeToken: action.challengeToken,
        error: null,
      }
    case 'ERROR':
      return { ...state, error: action.message }
    case 'RESET':
      return initialLoginState
  }
}
